import AppHeader from "../../layout/AppHeader";
import CockpitBillingAdmin from '../../xpost/views/dashboard/CockpitBillingAdmin.vue';
import CockpitBillingUser from '../../xpost/views/dashboard/CockpitBillingUser.vue';
import GraphBilling from '../../xpost/views/dashboard/GraphBilling.vue';
import Payment from '../../xpost/views/dashboard/financial/payment/Payment.vue';
import InvoiceExcelDashboard from '../../xpost/views/services/financial/invoice.excel/InvoiceExcelDashboard'

const FinancialRoutes = [
    {
        path: "/cockpit/financeiro/usuario",
        name: "cockpit.user.billing",
        components: {
            header: AppHeader,
            default: CockpitBillingUser,
        }
    },
    {
        path: "/cockpit/financeiro/administrador",
        name: "cockpit.admin.billing",
        components: {
            header: AppHeader,
            default: CockpitBillingAdmin,
        }
    },
    {
        path: "/cockpit/financeiro/grafico",
        name: "cockpit.graph.billing",
        components: {
            header: AppHeader,
            default: GraphBilling,
        }
    },
    {
        path: "/cockpit/financeiro/pagamento",
        name: "financial.payment",
        components: {
            header: AppHeader,
            default: Payment,
        }, 
    }, 
    {
        path: "/financeiro/planilha",
        name: "invoice.excel",
        components: {
            header: AppHeader,
            default: InvoiceExcelDashboard,
        }
    },
]

export default FinancialRoutes;
